import axios from "axios";
import {Address} from "./Address";
import {URl} from "./Common";
import Cookies from 'js-cookie';
const COOKIE_NAME = 'userId';
const  COOKIE_TOKE= 'idtoken';
// API  Registration
  export const Register = async (androidId) => {
    const address=await  Address()
    const { data } = await axios.post(`${URl}/loginorregister`, {android_id:androidId});
       Cookies.set(COOKIE_NAME,data.user_id,); 
       Cookies.set(COOKIE_TOKE,data.idtoken,);
      //  Cookies.set(ANDROID_ID,androidId,);
    return data;
  }; 
  // Game Listing 
  export const Games = async (user_id) => {
    const address=await  Address()
    const { data } = await axios.post(`${URl}/gamelist`, {user_id},{
  });
  return data;
  };

  export const ALLGames = async (user_id) => {
    const address=await  Address()
    const { data } = await axios.post(`${URl}/allgamelist`, {user_id},{
  });
  return data;
  };

  export const ALLFeaturedGameList = async (user_id) => {
    const address=await  Address()
    const { data } = await axios.post(`${URl}/allfeaturedlist`, {user_id},{
  });
  return data;
  };

  // Game Listing 
  export const List = async ({idtoken}) => {
    const address=await  Address()
    const { data } = await axios.post(`${URl}/goldgame/gameContestList`, {user_address:address},{
      headers: {
        Idtoken: idtoken,
      },
  });
  return data;
  };
 
  export const Leader = async ({ user_id}) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/leaderboardapp`,{user_id:user_id},{
  });
  return data;
}
 export const UserProfile = async ({ user_id, idtoken }) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/Userheaderdetail/userProfileData`,{user_id:3},{
        headers: {
          Idtoken: idtoken,
        },
  });

  return data;
}

 export const getUserProfile = async ({ user_id, idtoken }) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/useractivity`,{user_id:user_id},{
        headers: {
          Idtoken: idtoken,
        },
  });

  return data;
}

 export const Gamedetails = async ({ user_id, idtoken ,contest_id}) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/gamesingledata`,{contest_id:contest_id,user_id:user_id},{
        headers: {
          Idtoken: idtoken,
        },
  });
  return data;
}

 export const verifyCode = async ({android_id, verification_code}) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/verifywallet`,{android_id:android_id,verification_code:verification_code});
  return data;
}
 
export const likeDislike = async ({user_id, contest_id, selection_type, idtoken}) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/gamelikedislike`,{user_id:user_id,contest_id:contest_id, selection_type:selection_type},{
        headers: {
          Idtoken: idtoken
        }
      });
  return data;
}

export const review = async ({user_id, contest_id, rating, idtoken}) => {
      const address=await  Address()
      const { data } = await axios.post(`${URl}/gamereviewupdate`,{user_id:user_id,contest_id:contest_id, rating:rating},{
        headers: {
          Idtoken: idtoken
        }
      });
  return data;
}